import * as Sentry from '@sentry/browser';
import type { ReactNode } from 'react';

export const ErrorReporter = Sentry;

export const sentryNavigationIntegration = {
  name: 'NoopNavigation' as const,
  registerNavigationContainer: () => {},
  setupOnce: () => {},
};

export const sentryIntegrations = [
  // Skip low-value web vitals for logged-in B2B users (no SEO need). LCP/FCP/CLS/TTFB measurements + pageload/navigation transactions are preserved.
  Sentry.browserTracingIntegration({
    enableInp: false,
    enableLongAnimationFrame: false,
    enableLongTask: false,
  }),
];

export const {
  getActiveSpan,
  getRootSpan,
  spanToJSON,
  startSpan,
  startSpanManual,
} = Sentry;

export const getActiveRootSpan = () => {
  const active = Sentry.getActiveSpan();
  return active ? Sentry.getRootSpan(active) : undefined;
};

export const spanIsSampled = (span: {
  spanContext: () => { traceFlags: number };
}) => span.spanContext().traceFlags === 0x1;

export const TimeToFullDisplay = ({ children }: { children?: ReactNode }) =>
  children;
